
import GetNewRequestedClientAPI from "./GetNewRequestedClientAPI";
const GetNewRequestedClientServices = async (): Promise<any> => {
    try {
        const res = await GetNewRequestedClientAPI()
        return res;
    } catch (error) {
        throw error;
    }
};
export default GetNewRequestedClientServices;
